<template>
  <v-select
    label="Limit"
    prepend-icon="mdi-filter-variant"
    :items="items"
    v-model="limit"
    @change="changed"
    dense
    hide-details
    :menu-props="{ bottom: true, offsetY: true }"
    outlined
    class="limit"
  >
  </v-select>
</template>

<script lang="ts">
import Vue from "vue";
import VueTypes from "vue-types";

export default Vue.extend({
  name: "LimitComp",

  data() {
    return {
      items: [10, 20, 30, 50, 100],
    };
  },
  props: {
    value: VueTypes.number,
  },
  methods: {
    changed() {
      this.$emit("changed", { key: "limit", val: this.value });
      this.$emit("input", this.limit);
    },
  },
  computed: {
    limit: {
      get(): number {
        return this.value;
      },
      set(val: number) {
        this.$emit("input", val);
      },
    },
  },
});
</script>

<style>
.limit {
  width: 120px;
}
</style>
